import React, { useEffect, useState } from "react";
import { Tooltip, Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  explainAvailableRemnantsManage,
  AvailableExplainResult,
} from "api/RemnantsManage";

type Props = {
  article: string;
  warehouseId: number;
  value: React.ReactNode;
};

/** Value + info icon; hint loads on icon hover (lazy). */
const AvailableExplainCell: React.FC<Props> = ({
  article,
  warehouseId,
  value,
}) => {
  const [data, setData] = useState<AvailableExplainResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setData(null);
    setError(null);
    setLoading(false);
  }, [article, warehouseId, value]);

  const load = async () => {
    if (loading) return;
    setLoading(true);
    setError(null);
    try {
      const res = await explainAvailableRemnantsManage({
        article,
        warehouse_id: warehouseId,
      });
      setData(res);
    } catch {
      setError("Не удалось загрузить разбор");
    } finally {
      setLoading(false);
    }
  };

  const title = (
    <pre
      style={{
        margin: 0,
        maxWidth: 420,
        whiteSpace: "pre-wrap",
        fontSize: 12,
        fontFamily:
          "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
      }}
    >
      {loading && !data ? (
        <Spin size="small" />
      ) : error ? (
        error
      ) : data ? (
        data.lines.join("\n")
      ) : (
        "…"
      )}
    </pre>
  );

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        maxWidth: "100%",
      }}
    >
      <span>{value}</span>
      <Tooltip
        title={title}
        placement="left"
        mouseEnterDelay={0.15}
        overlayInnerStyle={{ maxWidth: 460 }}
        onOpenChange={(open) => {
          if (open) void load();
        }}
      >
        <InfoCircleOutlined
          style={{ color: "#1677ff", cursor: "help", fontSize: 12 }}
          onClick={(e) => e.stopPropagation()}
        />
      </Tooltip>
    </span>
  );
};

export default AvailableExplainCell;
